// tslint:disable
/**
 * LXBackend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from '../runtime';
/**
 * 
 * @export
 * @interface Transcripts
 */
export interface Transcripts {
    /**
     * 
     * @type {string}
     * @memberof Transcripts
     */
    languageCode: string;
    /**
     * 
     * @type {string}
     * @memberof Transcripts
     */
    transcript: string;
}

export function TranscriptsFromJSON(json: any): Transcripts {
    return {
        'languageCode': json['language_code'],
        'transcript': json['transcript'],
    };
}

export function TranscriptsToJSON(value?: Transcripts): any {
    if (value === undefined) {
        return undefined;
    }
    return {
        'language_code': value.languageCode,
        'transcript': value.transcript,
    };
}


